export default __webpack_public_path__ + "static/media/drawn-wind-turbine-existing-icon.0fb9d06e.svg";